import { useContext } from 'react';
import { UnitSystemContext } from './UnitConversionProvider';
// @ts-ignore
const useUnitSystem = () => useContext(UnitSystemContext);
export default useUnitSystem;
//# sourceMappingURL=useUnitSystem.js.map